<div class="sales-summary-info-box">
  <mat-icon [svgIcon]="IconNames.ice_praise" />
  <div class="sales-summary-numbers-row">
    <span class="sales-summary">
      <div class="sales-summary-amount">{{ salesSummary.salesToday }}</div>
      <div class="sales-summary-text">Siste døgn</div>
    </span>
    <span class="sales-summary">
      <div class="sales-summary-amount">{{ salesSummary.salesThisWeek }}</div>
      <div class="sales-summary-text">Denne uken</div>
    </span>
    <span class="sales-summary">
      <div class="sales-summary-amount">{{ salesSummary.salesThisMonth }}</div>
      <div class="sales-summary-text">Denne måneden</div>
    </span>
  </div>
</div>
